/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CATEGORYCOURSE_ADD = 'CATEGORYCOURSE_ADD';
export const CATEGORYCOURSE_BEGIN = 'CATEGORYCOURSE_BEGIN';
export const CATEGORYCOURSE_FAILURE = 'CATEGORYCOURSE_FAILURE';
export const CATEGORYCOURSE_CLEAR = 'CATEGORYCOURSE_CLEAR';

export function fetchCategoryCourse(data) {
    return async dispatch => {
        dispatch(categoryCourseBegin());
        await ApiService.getCategoriesCourse(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCategory');
                    dispatch(categoryCourseAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(categoryCourseError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}


export const categoryCourseBegin = () => ({
    type: CATEGORYCOURSE_BEGIN,
});

export const categoryCourseAdd = data => ({
    type: CATEGORYCOURSE_ADD,
    payload: { data }
})

export const categoryCourseError = () => ({
    type: CATEGORYCOURSE_FAILURE,
})

export const categoryCourseClear = () => ({
    type: CATEGORYCOURSE_CLEAR,
})